export default __webpack_public_path__ + "static/Dennis_van_Otterloo_1-68a625796987210a187bc3a9b67659a8.jpg";